import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'client/environments/environment';
import {
  TeamMember,
  TeamMemberListItem,
  TeamListResponse,
} from '../models/team-member.model';

@Injectable({ providedIn: 'root' })
export class TeamService {
  private readonly apiBase = (environment.contentApiUrl || '').replace(/\/$/, '');

  constructor(private readonly http: HttpClient) {}

  /**
   * Fetch list of active team members sorted by displayOrder.
   */
  list(): Observable<TeamListResponse> {
    // Backend returns flat NestJS DTO, not Strapi-wrapped format
    return this.http
      .get<TeamListResponse>(`${this.apiBase}/api/team-members`)
      .pipe(
        map((response) => ({
          items: response.items || [],
          meta: response.meta || { total: 0 },
        })),
      );
  }

  /**
   * Fetch detailed team member by slug.
   */
  detail(slug: string): Observable<TeamMember> {
    // Backend returns flat NestJS DTO, not Strapi-wrapped format
    return this.http.get<TeamMember>(`${this.apiBase}/api/team-members/${slug}`);
  }
}
